import { CreditBookmark } from 'types/credit';
import create from 'zustand';
import { persist } from 'zustand/middleware';
import { version } from '../../package.json';

type Store = {
  selectedSourceInstitution: string | null;
  setSelectedSourceInstitution: (sourceInstitution: string | null) => void;
  recentInstitutions: string[];
  addRecentInstitution: (institutionID: string) => void;
  setRecentInstitutions: (institutionIDs: string[]) => void;
  creditBookmarks: CreditBookmark[];
  addCreditBookmark: (creditBookmark: CreditBookmark) => void;
  removeCreditBookmark: (creditBookmarkID: string) => void;
  setCreditBookmarks: (creditBookmarks: CreditBookmark[]) => void;
  searchCategory: string;

  setSearchCategory: (searchCategory: string) => void;
};

export const usePersistentStore = create<Store>()(
  persist(
    (set) => ({
      selectedSourceInstitution: null,
      setSelectedSourceInstitution: (selectedSourceInstitution) =>
        set((state) => {
          if (selectedSourceInstitution) {
            state.addRecentInstitution(selectedSourceInstitution);
          }
          return { selectedSourceInstitution };
        }),
      recentInstitutions: [],
      addRecentInstitution: (instituitonID) =>
        set((state) => {
          let recentInstitutions = [...state.recentInstitutions];
          if (recentInstitutions.includes(instituitonID)) {
            recentInstitutions = recentInstitutions.filter((recent) => recent !== instituitonID);
          }
          recentInstitutions.unshift(instituitonID);
          recentInstitutions = recentInstitutions.slice(0, 3);
          return { recentInstitutions };
        }),
      setRecentInstitutions: (institutionIDs: string[]) => set({ recentInstitutions: institutionIDs }),
      creditBookmarks: [],
      addCreditBookmark: (creditBookmark) =>
        set((state) => ({ creditBookmarks: Array.from(new Set([...state.creditBookmarks, creditBookmark])) })),
      removeCreditBookmark: (creditBookmarkID) =>
        set((state) => ({
          creditBookmarks: state.creditBookmarks.filter((bookmark) => bookmark.creditItemID !== creditBookmarkID),
        })),

      setCreditBookmarks: (creditBookmarks) => set({ creditBookmarks }),
      searchCategory: 'ARTICULATION',
      setSearchCategory: (searchCategory) => set({ searchCategory }),
    }),
    { name: 'credit-calculator', version: parseInt(version) },
  ),
);
